import React, { useState } from "react";

import { Divider, makeStyles, Typography } from "@material-ui/core";

import Table from "../../components/Table";
import { Card, CardContent, CardActions } from "../../components/Card";
import Text from "../../components/Text";
import PageItem from "../../components/PageItem";
import { DateInput } from "../../components/Form";
import Grid from "../../components/Grid";
import Button from "../../components/Button";
import moment from "moment";

export default function FranchiseSystemTable({}) {
  const data = [];
  const [newData, setNewData] = useState({
    dateStart: new Date(),
    dateEnd: new Date(),
    page: 1,
    pageMax: null,
    pageSize: 10,
    pageArray: [],
  });

  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }
  const useStyles = makeStyles({
    DocumentContainerEnd: {
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-end",
    },
    DocumentContainerButtonEnd: {
      display: "flex",
      alignItems: "flex-end",
    },
  });
  const classes = useStyles();

  return (
    <Card>
      <CardContent>
        <Grid container spacing={1}>
          <Grid item xs={6} sm={2}>
            <Typography color="primary" style={{ fontSize: 15 }}>
              日期
            </Typography>
            <DateInput
              format="yyyy年MM月dd日"
              value={newData.dateStart}
              onChange={(v) => changeData("dateStart", v, true)}
              fullWidth
            />
          </Grid>
          <Grid item xs={6} sm={2}>
            <Typography color="primary" style={{ fontSize: 15 }}>
              至
            </Typography>
            <DateInput
              format="yyyy年MM月dd日"
              value={newData.dateEnd}
              minDate={newData.dateStart}
              onChange={(v) => changeData("dateEnd", v, true)}
              fullWidth
            />
          </Grid>
          <Grid item classes={{ root: classes.DocumentContainerButtonEnd }}>
            <Button size="small" color="primary" variant="contained">
              搜尋
            </Button>
          </Grid>
        </Grid>
        <Table
          data={data}
          tableWidth={2}
          header={["編號", "店名", "負責人", "起", "訖", "聯絡地址", "備註"]}
          columns={[
            (item) => <Text>{item.code}</Text>,
            (item) => <Text>{item.numberDebtor}</Text>,
            (item) => <Text>{item.address}</Text>,
            (item) => <Text>{item.date}</Text>,
            (item) => <Text>{item.status}</Text>,
            (item) => <Text>{item.floor}</Text>,
            (item) => <Text>{item.floorMillion}</Text>,
          ]}
        />
      </CardContent>
      <Divider />
      <CardContent>
        <Typography>{"備註："}</Typography>
        <Typography>
          {
            "1、因不動產、法拍物件遍及全台，且每一商圈會有法拍標的及其數量、投資性之情形有異，故不限制有意加盟者必須開設實體店面，亦未約束每一商圈可開設之加盟店數量。上表係截至 110.08.23止之「富屋房屋」連鎖事業體系門市，最新門市資料，則可至官方網站（網址：http://www.5137.com.tw/）查看。"
          }
        </Typography>
      </CardContent>
      <Divider />
      <CardActions>
        <PageItem
          data={newData.pageArray}
          page={newData.page}
          onChangePage={(e) => changeData("page", e, true)}
        />
      </CardActions>
    </Card>
  );
}
